import * as React from 'react';
import { forwardRef } from 'react';

import { FieldFormGroupProps } from '../field_form_group';
import {
  type ResizableTextAreaFormControlProps,
  type ResizableTextAreaFormControlType,
} from '../resizable_text_area_form_control';
import { FormikFieldFormGroup } from './formik_field_form_group';
import { FormikResizableTextAreaFormControl } from './formik_resizable_text_area_form_control';

type ResizableTextAreaFormGroupType = ResizableTextAreaFormControlType;
type ResizableTextAreaFormGroupProps = ResizableTextAreaFormControlProps & FieldFormGroupProps & { name: string };

export const FormikResizableTextAreaFormGroup = forwardRef<
  ResizableTextAreaFormGroupType,
  ResizableTextAreaFormGroupProps
>(({ help, label, children, ...textarea }, ref) => (
  <FormikFieldFormGroup name={textarea.name} help={help} label={label} id={textarea.id}>
    <FormikResizableTextAreaFormControl ref={ref} {...textarea} />
  </FormikFieldFormGroup>
));
